import React from 'react'
// components
import Header from 'components/UI/Modal/Header'
import DrawerModal from 'components/UI/Drawer'
import CreateForm from './CreateForm'
// hooks
import { useModalData } from 'hooks/index'
import { useShowModal } from 'hooks/useShowModal'
// constants
import { Modals } from 'constants/modals'
// types
import { IApiClientCreatedCredentials } from 'types/graphql'
// views
import { Wrapper } from './views'

const ApiClientCreateModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen }
  } = useModalData({ modalType: Modals.API_CLIENT_CREATE_MODAL })

  const { showModal: showSecretModal } = useShowModal({ modalType: Modals.API_CLIENT_SECRET_MODAL })

  const handleCreated = (credentials: IApiClientCreatedCredentials) => {
    hideModal()
    showSecretModal({ credentials })
  }

  return (
    <DrawerModal isOpen={isOpen} width='620px' hideModal={hideModal}>
      <Header handleClearClick={hideModal}>Create API Client</Header>
      <Wrapper>
        <CreateForm hideModal={hideModal} onCreated={handleCreated} />
      </Wrapper>
    </DrawerModal>
  )
}

export default ApiClientCreateModal
